import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';

export default () => (
  <Result
    status="404"
    title="404"
    subTitle={`${
      process.env.NODE_ENV === 'development' ? '请先确认是否配置了对应路由' : '您访问的网址不存在'
    }`}
    extra={
      process.env.NODE_ENV === 'development' ? null : (
        <Link to="/" replace>
          <Button type="primary">返回首页</Button>
        </Link>
      )
    }
  />
);
